// Re-export types
export * from './types'

// Import comparison data
import { advisoryAi } from './advisory-ai'
import { saturn } from './saturn'
import type { ComparisonPage } from './types'

// All comparison pages
export const comparisonPages: Record<string, ComparisonPage> = {
  'advisory-ai': advisoryAi,
  saturn: saturn,
}

// Helper function to get a comparison by slug
export function getComparisonBySlug(slug: string): ComparisonPage | undefined {
  return comparisonPages[slug]
}

// Helper function to check if a comparison exists
export function comparisonExists(slug: string): boolean {
  return slug in comparisonPages
}
